import React from "react";

const IELTSWritingIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 29 29"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.0985 0.397461C23.6285 -0.132487 24.4877 -0.132487 25.0176 0.397461L28.4102 3.79C28.9401 4.31995 28.9401 5.17917 28.4102 5.70912L18.2326 15.8867C17.9781 16.1412 17.6329 16.2842 17.273 16.2842H13.8805C13.131 16.2842 12.5234 15.6767 12.5234 14.9272V11.5346C12.5234 11.1747 12.6664 10.8296 12.9209 10.5751L23.0985 0.397461ZM15.2375 12.0967V13.5702H16.7109L25.5315 4.74956L24.0581 3.27613L15.2375 12.0967Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.34247 13.9175C2.20205 13.0268 3.36787 12.5264 4.58349 12.5264H9.16699C9.89024 12.5264 10.4766 13.1339 10.4766 13.8834C10.4766 14.6328 9.89024 15.2404 9.16699 15.2404H4.58349C4.06251 15.2404 3.56287 15.4549 3.19448 15.8366C2.8261 16.2183 2.61914 16.7361 2.61914 17.2759C2.61914 17.8158 2.8261 18.3335 3.19448 18.7153C3.56287 19.097 4.06251 19.3115 4.58349 19.3115H24.227C25.4426 19.3115 26.6085 19.8119 27.4681 20.7026C28.3276 21.5933 28.8105 22.8014 28.8105 24.061C28.8105 25.3207 28.3276 26.5287 27.4681 27.4195C26.6085 28.3102 25.4426 28.8106 24.227 28.8106H10.4766C9.7533 28.8106 9.16699 28.203 9.16699 27.4536C9.16699 26.7041 9.7533 26.0965 10.4766 26.0965H24.227C24.748 26.0965 25.2477 25.8821 25.616 25.5004C25.9844 25.1186 26.1914 24.6009 26.1914 24.061C26.1914 23.5212 25.9844 23.0034 25.616 22.6217C25.2477 22.2399 24.748 22.0255 24.227 22.0255H4.58349C3.36787 22.0255 2.20205 21.5251 1.34247 20.6344C0.482902 19.7437 0 18.5356 0 17.2759C0 16.0163 0.482902 14.8082 1.34247 13.9175Z"
    />
  </svg>
);

export default IELTSWritingIcon;
